<template>
  <div>
    <section class="resource-directory pt-4 pb-4" id="resource-directory">
      <b-container>
        <b-row>
          <b-col cols="12" md="6" class="mb-4">
            <h4 class="section-title d-inline-block">{{ portalConfig.text.topPickResources }}</h4>
          </b-col>
          <b-col cols="12" md="6">
            <b-link to="/ResourceDirectory" class="resource-directory__link d-none d-md-block">View More <font-awesome-icon :icon="['fas', 'caret-right']" /></b-link>
          </b-col>
        </b-row>
        <GetData :endpoint='"articles/" + portalConfig.portalName + "/resources/top-picks" + count + page' :key="componentKeyTPR">
          <FrogResourceCard
            :cols="12" :md="6" :lg="3"
            slot-scope="{ response: resource }"
            :result="resource.results"
            :pagination="true"
            :prevData="resource.previousCursor"
            :nextData="resource.nextCursor"
            @nextResourcePage="nextResourcePage(resource.nextCursor)"
            @previousResourcePage="prevResourcePage(resource.previousCursor)"
          />
        </GetData>
      </b-container>
    </section>
  </div>
</template>

<script>
import GetData from '@/services/GetData'
import FrogResourceCard from '@/components/FrogResourceCard'
import { mapGetters } from 'vuex'

const breakpoints = {
  sm: 540,
  md: 720,
  lg: 960
}

export default {
  name: 'SectionResources',
  props: {
    result: Array,
    breakpoints: Object
  },
  components: {
    GetData,
    FrogResourceCard
  },
  data: () => {
    return {
      componentKeyTPR: 0,
      page: '',
      count: ''
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.resizeHandler()
  },
  methods: {
    forceRerender () {
      this.componentKeyTPR += 1
    },
    nextResourcePage (next) {
      this.componentKeyTPR++
      this.page = '&next=' + next
    },
    prevResourcePage (prev) {
      this.componentKeyTPR++
      this.page = '&previous=' + prev
    },
    resizeHandler (e) {
      const clientWidth = window.innerWidth
      if (clientWidth < breakpoints.md) {
        this.count = '?count=1'
      } else {
        this.count = '?count=4'
      }
    }
  }
}
</script>
